export default "/assets/images/app-rooms-video.mp4?77644ae61ef03576ad3dde9941ce67c4";